import { gql } from '@zenbusiness/application-commons-graphql';

export const MARK_DONE_NEXTUP_CARD_MUTATION = gql`
  mutation markDoneNextUpCard($params: MarkDoneNextUpCardInput!) {
    markDoneNextUpCard(params: $params) {
      success
    }
  }
`;
